import { ErrorTrigger } from 'store/types';

export function extractErrorMessageFromResponse(errorTrigger: ErrorTrigger) {
	return errorTrigger.data?.validation?.body?.message ?? errorTrigger.data?.errors[0].msg ?? errorTrigger.error;
}
